<template>
  <div class="personal-mine-handle" v-loading="isLoading">
    <!-- <Nothing v-if="isNothing" :config="{type: onlyReal ? 'img_no_data' : 'img_no_task',tip:onlyReal ? '暂无任务' : '暂无任务，去搬砖~'}"></Nothing> -->
    <div class="content">
      <div class="list">
        <div class="list-task" :style="{height:todoIsOpen ? 'auto' : '48px'}">
          <div class="list-task-title">
            <div><i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': todoIsOpen}" @click="todoIsOpen = !todoIsOpen"></i><span>未完成</span><a>{{todoTotal}}</a></div>
          </div>
          <List @taskStatusChange="taskStatusChange" :dataset="todoList" :finish="todoFinish" :load="todoLoad" @taskClick="taskClick" @projectClick="projectClick" :onlyReal="onlyReal" @openDetail="openDetail" :check="check"></List>
          <div v-if="todoList.length === 0 && todoIsOpen" class="not-task-box">
            <Nothing :config="{type: onlyReal ? 'img_no_data' : 'img_no_task',tip:onlyReal ? '暂无任务' : '暂无任务，去搬砖~'}"></Nothing>
          </div>
        </div>
        <div class="list-task" :style="{height:completeIsOpen ? 'auto' : '48px'}">
          <div class="list-task-title">
            <div><i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': completeIsOpen}" @click="completeIsOpen = !completeIsOpen"></i><span>已完成</span><a>{{completeTotal}}</a></div>
          </div>
          <List @taskStatusChange="taskStatusChange" :dataset="completeList" :finish="completeFinish" :load="completeLoad" @taskClick="taskClick" @projectClick="projectClick" :onlyReal="onlyReal" @openDetail="openDetail" :check="check"></List>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import List from './list.vue'
import Nothing from '@/components/nothing'
import api from '@/services/api/mine/mine'
import bus from '@/bus'
export default {
  props: ['onlyReal', 'uid'],
  components: {
    Nothing,
    List
  },
  data() {
    let _this = this
    return {
      complete: {
        page: 1,
        per_page: 20,
        uid: _this.uid
      },
      todo: {
        page: 1,
        per_page: 20,
        sort_rule: 'due_date_sort',
        uid: _this.uid
      },
      completeList: [], // 已完成列表
      completeTotal: 0, // 已完成总数
      completeIsOpen: true, // 已完成是否展开
      completeFinish: false,
      todoList: [], // 未完成列表
      todoTotal: 0,// 未完成总数
      todoIsOpen: true, // 未完成是否展开
      todoFinish: false,
      colorList: [],// 颜色列表
      check: ''
    }
  },
  computed: {
    ...mapState('mine/mine', {
      queryMsg: state => state.queryMsg
    }),
    isLoading() {
      return (!this.todoFinish && this.todoList.length === 0) || (!this.completeFinish && this.completeList.length === 0)
    },
    isNothing() {
      let fl = this.completeList.length === 0 && this.todoList.length === 0 && this.completeFinish && this.todoFinish && !this.isLoading
      this.$emit('nothing', fl)
      return fl
    },
  },
  watch: {
    queryMsg: {
      handler() {
        this.complete.keyword = this.queryMsg.keyword
        this.complete.my_execution = this.queryMsg.my_execution
        this.complete.project_id = this.queryMsg.project_id

        this.todo.keyword = this.queryMsg.keyword
        this.todo.my_execution = this.queryMsg.my_execution
        this.todo.project_id = this.queryMsg.project_id
        this.todo.sort_rule = this.queryMsg.sort_rule
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // this.init()
    bus.$on('updateTask', () => {
      this.init()
    })
  },
  destroyed() {
    bus.$off('updateTask')
  },
  methods: {
    ...mapActions('task/task', ['updateStatus']),
    init() {
      this.complete.page = 1
      this.completeList = []
      this.completeTotal = 0
      this.todo.page = 1
      this.todoList = []
      this.todoTotal = 0
      this.$nextTick(() => {
        this.getCompleteTask()
        this.getTodoTask()
      })
    },
    getCompleteTask() {
      this.completeFinish = false
      return api.relatedToMeCompletedTasksIndex({ ...this.complete }).then(res => {
        this.completeList.push(...res.data)
        this.completeTotal = res.total
        if (this.completeList.length === this.completeTotal || res.data.length === 0) {
          this.completeFinish = true
        } else {
          this.completeFinish = false
        }
      })
    },
    getTodoTask() {
      this.todoFinish = false
      return api.relatedToMeUndoneTasksIndex({ ...this.todo }).then(res => {
        this.todoList.push(...res.data)
        this.todoTotal = res.total
        if (this.todoList.length === this.todoTotal || res.data.length === 0) {
          this.todoFinish = true
        } else {
          this.todoFinish = false
        }
      })
    },
    async completeLoad(resolve) {
      this.complete.page = this.complete.page + 1
      await this.getCompleteTask()
      resolve()
    },
    async todoLoad(resolve) {
      this.todo.page = this.todo.page + 1
      await this.getTodoTask()
      resolve()
    },
    async taskStatusChange({ item, index, isCompete }) {
      await this.updateStatus({ task_id: item.id, task_stage: isCompete ? '进行中' : '已完成' })
      let key = isCompete ? 'completeTotal' : 'todoTotal' // 判断那个数组
      this[key] - 1 < 0 ? this[key] = 0 : this[key] = this[key] - 1 // 相应数量-1
      // if (isCompete) {
      //   this.todoList = []
      //   this.todoTotal = 0
      //   this.todo.page = 1
      //   this.completeList.splice(index, 1)
      //   this.$nextTick(() => {
      //     this.getTodoTask()
      //   })
      // } else {
      //   this.completeList = []
      //   this.completeTotal = 0
      //   this.complete.page = 1
      //   this.$nextTick(() => {
      //     this.getCompleteTask()
      //   })
      //   this.todoList.splice(index, 1)
      // }
      this.todoList = []
      this.todoTotal = 0
      this.todo.page = 1
      this.completeList = []
      this.completeTotal = 0
      this.complete.page = 1
      this.$nextTick(() => {
        this.getCompleteTask()
        this.getTodoTask()
      })
    },
    taskClick(data) {
      this.$emit('taskClick', data)
    },
    projectClick(data) {
      this.$emit('projectClick', data)
    },
    openDetail(id) {
      this.check = id
    }
  }
}
</script>
<style lang="scss">
.personal-mine-handle {
  min-height: 100% ;
  padding: 0 40px;
}
</style>
